<template>
	<div>
		<!-- 购物车列表 -->
		<div class="cartTableList">
			<div>
				<el-popover trigger="click" placement="top" v-model="emptyVisible">
					<p>{{ $t("Are you sure you want to delete selected items") }}?</p>
					<div style="text-align: center; margin: 0">
						<el-button size="mini" type="text" style="color: #218da0" @click="hidePopover">
							{{ $t("Cancel") }}
						</el-button>
						<el-button style="color: #218da0" size="mini" @click="clickDeleteSel">{{ $t("Confirm") }}
						</el-button>
					</div>
					<el-button type="primary" style="font-size: 16px" size="mini" slot="reference" class="xmvogueColor"
						@click.stop>{{ $t("Delete Selected Items") }}
					</el-button>
				</el-popover>

				<el-popover trigger="click" placement="top" v-model="visible">
					<p>{{ $t("Are you sure you want to empty the cart") }}?</p>
					<div style="text-align: center; margin: 0">
						<el-button size="mini" type="text" style="color: #218da0" @click="hidePopover">
							{{ $t("Cancel") }}
						</el-button>
						<el-button style="color: #218da0" size="mini" @click="clearCart" v-loading="isLoading.empty">
							{{ $t("Confirm") }}
						</el-button>
					</div>
					<el-button type="primary" style="font-size: 16px; margin: 0 10px" size="mini" slot="reference"
						class="xmvogueColor" @click.stop>
						{{ $t("Empty Cart") }}
					</el-button>
				</el-popover>

				<el-button type="info" size="mini" class="bdXmColor" @click="ImportCartShow">{{ $t("Import Cart") }}</el-button>
				<el-button type="info" size="mini" class="bdXmColor" @click="exportCarts">{{ $t("Export") }}</el-button>

				<span style="margin-left: 50px">{{ $t("Product Category") }}:</span>
				<el-cascader :placeholder="$t('Please Select Product Category')" size="medium" v-model="goodsTypeValue"
					:options="GoodsTypes" :props="{ checkStrictly: true }" clearable style="width: 260px">
				</el-cascader>
        <span v-if="userInfo.pid === 0">
          <span style="margin-left: 50px">{{ $t("Childs") }}：</span>
          <el-select v-model="queryChild" placeholder="请选择" clearable @change="handleChangeChild(queryChild)">
            <el-option
              v-for="item in childs"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </span>
			</div>

      <div v-if="showTips !== '' && $i18n.locale !=='zh-CN' " style="color: #ff0000">Please note that you are currently operating in your sub-account {{showTips }}</div>
      <div v-if="showTips !== '' && $i18n.locale ==='zh-CN'" style="color: #ff0000">请注意，您当前在子账号{{showTips }}中操作</div>

			<div style="margin: 10px 0" v-if="userInfo.pid === 0">
        <div class="showDivTotal">
          {{ $t("Total") }}：{{ $t("Price symbol") }}{{ cartTotal.total }}
        </div>
				<el-input placeholder="sku" size="big" style="width: 428px; margin: 0 10px 0 0" v-model="querySkuCode">
				</el-input>
				<el-select v-model="optionsBreakUp.action" :placeholder="$t('Select method of settlement')" size="big"
					style="margin-right: 10px">
					<el-option v-for="item in optionsBreakUp.list" :key="item.value" :label="item.label"
						:value="item.value">
					</el-option>
				</el-select>
				<el-button type="primary" size="medium" class="xmvogueColor" @click="submitOrder"
					v-show="hasShowSubmitOrderInput">
					{{ $t("Proceed to Checkout") }}
				</el-button>
				<i class="el-icon-loading" v-show="hasShowSubmitOrderInput === false"></i>
			</div>
			<div style="margin: 10px 0" v-if="recommendList.length > 0">
				<!-- 产品推荐区域 -->
				<div class="recommend-box">
				<div class="recommend-title">
					<span class="left">{{ $t("Product Recommendations") }}</span>
					<span class="refresh" @click="loadRecommendList">
					<i class="el-icon-refresh"></i>{{ $t("Refresh") }}
					</span>
				</div>
				
				<!-- 有数据时 -->
				<div class="recommend-list" v-if="recommendList.length > 0">
					<div class="recommend-card" v-for="item in recommendList" :key="item.item_no" @click="toGoodsInfoPage(item.item_no)">
						<!-- 标签 -->
						<span class="card-tag" v-if="item.tag" :class="item.tagType">{{ item.tag }}</span>
						
						<!-- 图片 -->
						<div class="card-img">
							<img :src="`https://hwimg.xmvogue.com/thumb/${item.item_no}.jpg?x-oss-process=style/800`" alt="">
						</div>
						
						<!-- 名称 -->
						<div class="card-name">{{ item.GoodsName }}</div>
						
						<!-- 价格（权限控制） -->
						<div class="card-price" v-if="userInfo.pid === 0 || userInfo.show_price === 1">
							<span class="price-now">{{ $t("Price symbol") }}{{ item.price?.toFixed(2) }}</span>
							<span class="price-origin" v-if="item.sell_price > item.price">{{ $t("Price symbol") }}{{ item.sell_price?.toFixed(2) }}</span>
						</div>
						
						<!-- 添加按钮 -->
						<button class="card-btn" @click.stop="addCarts(item)">{{ $t("Add to Cart") }}</button>
					</div>

					
				</div>
				
				<!-- 空状态 -->
				<div class="recommend-empty" v-else>
					<i class="el-icon-goods"></i>
					<p>{{ $t("No recommendations available") }}</p>
				</div>
				</div>
			</div>

			<div style="border: 1px solid #218da0; margin-top: 5px">
				<el-table ref="multipleTable" :data="tableData" class="main-table" tooltip-effect="dark"
					style="width: 100%; font-size: 16px; color: #1a1617" :header-cell-style="{ color: '#333333' }"
					@selection-change="handleSelectionChange" v-loading="isLoading.table" border>
					<el-table-column type="selection" width="55" align="center">
					</el-table-column>
					<el-table-column :label="$t('Picture')" width="120" align="center">
						<template slot-scope="scope">
							<viewer>
								<img height="100"
									:src="`https://hwimg.xmvogue.com/thumb/${scope.row.item_no}.jpg?x-oss-process=style/800`"
									class="mr-3" alt="..." style="cursor: pointer" />
							</viewer>
						</template>
					</el-table-column>

					<el-table-column :label="$t('Product Barcode')" width="150" align="center">
						<template slot-scope="scope">
							<!-- <a @click="toGoodsInfoPage(scope.row.item_no)">{{ scope.row.item_no }}</a> -->
							{{ scope.row.item_no }}
						</template>
					</el-table-column>

					<el-table-column prop="GoodsName" :label="$t('Name')" align="center">
						<template slot-scope="scope">
							<a @click="toGoodsInfoPage(scope.row.item_no)">{{scope.row.GoodsName }}</a>
						</template>
					</el-table-column>

					<el-table-column :label="$t('Certificate')" align="center">
						<template slot-scope="scope">
							<img width="30" :src="item" v-for="(item, index) in scope.row.file_type_icon_list_arr"
								:key="index"  alt=""/>
						</template>
					</el-table-column>

					<el-table-column :label="$t('Purchase Price')" align="center" width="120">
						<template slot-scope="scope">
							<div v-if="userInfo.pid === 0 || userInfo.show_price === 1">{{ $t("Price symbol") }}{{ scope.row.price.toFixed(2) }}</div>
						</template>
					</el-table-column>

					<el-table-column :label="$t('original price')" align="center" width="120">
						<template slot-scope="{row}">
              <div v-if="userInfo.pid === 0 || userInfo.show_price === 1">{{ $t("Price symbol") }}{{row.sell_price.toFixed(2) }}</div>
						</template>
					</el-table-column>

					<el-table-column :label="$t('Quantity')" align="center" width="260">
						<template v-slot="scope">
							<div v-if="scope.row.is_gift === 0">
								<el-input-number v-model="scope.row.num" :min="scope.row.num>=scope.row.spe?scope.row.spe:scope.row.num" :step="scope.row.spe" :max="scope.row.us_num"
									size="mini" @change="(currentValue, oldValue) =>handleChange(currentValue, oldValue, scope.row)">
								</el-input-number>
							</div>
							<div v-else>
								<el-tag size="mini">
									{{$t('Gift')}}
								</el-tag>
								{{ scope.row.num }}
							</div>
							
						</template>
					</el-table-column>

					<el-table-column :label="$t('Subtotal')" align="center" width="120">
						<template slot-scope="scope">
              <div v-if="userInfo.pid === 0 || userInfo.show_price === 1">{{ $t("Price symbol") }}{{ scope.row.total.toFixed(2) }}</div>
						</template>
					</el-table-column>

					<el-table-column :label="$t('Event')" align="center" width="150">
						<template slot-scope="{row}">
							<span v-if="row.dis_id > 0">{{$t('Discount activities')}}</span>
							<span v-else>{{$t('No activity')}}</span>
						</template>
					</el-table-column>

					<el-table-column prop="created_at" :label="$t('Count Down')" align="center">
						<template slot-scope="{ row }">
							<countdown :end-time="row.endTime" style="color: red">
								<span slot="process" slot-scope="{ timeObj }">
									{{ +timeObj.h + +timeObj.d * 24 }}h:{{ timeObj.m }}m:
									{{ timeObj.s }}s
								</span>
								<span slot="finish">Done!</span>
							</countdown>
						</template>
					</el-table-column>

					<el-table-column :label="$t('Operation')" align="center" width="120">
						<template slot-scope="scope">
							<div v-if="scope.row.is_gift === 0">
								<a class="el-icon-delete-solid" @click="deleteRow(scope.row)"></a>
							</div>
							<div v-else>
								<el-tag size="mini">
									{{$t('Gift')}}
								</el-tag>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</div>

      <!--悬浮层开始-->
      <div :class="showCartListInfo.listClass">
        <span style="margin: 0 40px" v-if="showCartListInfo.showSpan">{{$t("Continue Shopping") }}</span>
        {{ cartTotal.list }}
        <div v-if="userInfo.pid === 0">
          <span class="totalPirce1" v-if="showCartListInfo.showSpan">
					{{ $t("Total") }}：{{ $t("Price symbol") }}{{ cartTotal.total }}
				</span>
          <el-button v-if="showCartListInfo.showSpan" size="medium" style="margin-left: 50px; width: 180px"
                     @click="submitOrder">
            {{ $t("Proceed to Checkout") }}
          </el-button>
        </div>
      </div>
      <!--悬浮层结束-->

		</div>
		

		<div style="text-align: center; height: 150px" ref="footer">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
				:current-page="pages.currentPage" :page-sizes="[10, 20, 50, 100, 500, 800]" :page-size="pages.size"
				layout="total, sizes, prev, pager, next, jumper" :total="pages.total">
			</el-pagination>
		</div>

		<!-- 显示导入 -->
		<el-dialog :title="$t('Import Product to Shopping Cart')" :visible.sync="dialogVisible" width="30%"
			:before-close="handleClose" :show-close="false" :resize="false">
			<!-- <span>购物车导入</span> -->
			<div class="disDiv">
				<textarea class="textareaInput" :placeholder="$t('code,quantity')" v-model="textarea"></textarea>
			</div>

			<div class="respMessList" v-show="importGoodsDataSuccess.length > 0">
				<p style="
            height: 30px;
            line-height: 30px;
            text-indent: 1em;
            background: #218da0;
            color: white;
          ">
					Success：
				</p>
				<el-alert :title="item" v-for="(item, index) in importGoodsDataSuccess" :key="index" type="success"
					style="margin-top: 5px"></el-alert>
			</div>

			<!-- <div class="respMessList" v-show="importGoodsDataError.length>0"> -->
			<div class="respMessList" v-show="importGoodsDataError.length > 0">
				<p style="
            height: 30px;
            line-height: 30px;
            text-indent: 1em;
            background: brown;
            color: white;
          ">
					Error：
				</p>
				<el-alert :title="item" v-for="(item, index) in importGoodsDataError" :key="index" type="warning"
					style="margin-top: 5px"></el-alert>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">{{ $t("Close") }}</el-button>
				<el-button type="primary" class="xmvogueColor" @click="submitInerCart" v-show="submitOrderIng">
					{{ $t("Submit") }}
				</el-button>

				<el-button type="primary" class="xmvogueColor" v-show="submitOrderIng === false">
					<i class="el-icon-loading"></i>
				</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import cart from "./js/index";

export default cart
</script>
<style lang="scss" scoped>
	//显示消息列表
	.respMessList {
		margin-top: 10px;
		height: 200px;
		overflow: auto;
		border: 1px solid #218da0;
	}

	.cartTableList {
    width: 86%;
    margin: 0 auto 20px;
  }

	.xmvogueColor {
		background: #218da0;
		border-color: #218da0;
	}

	.bdXmColor {
		border-color: #218da0;
		font-size: 16px;
	}

	.el-dialog__header {
		border-bottom: 1px solid #218da0;
	}

	.el-textarea__inner,
	// .disDiv,
	.el-dialog {
		border-radius: 10px;
	}

	.textareaInput {
		border: 1px solid #218da0;
		border-radius: 5px;
		width: 100%;
		height: 180px;
		resize: none;
	}

	.el-textarea__inner {
		border: none;
		height: 198px;
	}

	//新的样式
	.showCartListInfo {
		padding: 5px;
		font-size: 20px;
		position: absolute;
		bottom: 0;
		background: rgb(33, 141, 160);
		color: white;
		border-radius: 10px;
		z-index: 99999;
		width: 80%;
	}

	.showCartListInfo2 {
		padding: 8px;
		margin-top: 5px;
		border-bottom: 1px solid rgb(33, 141, 160);
	}

	.totalPirce1 {
		margin-left: 11%;
	}

	//=========
	.showDivTotal {
		margin-top: 10px;
		font-size: 20px;
		color: rgb(255, 153, 0);
	}

	.hiddenDivTotal {
		display: none;
	}
	/*=== 修改 ===*/

	// ========= 产品推荐区域样式 =========
	// ========= 产品推荐区域样式 =========
	// ========= 产品推荐区域样式 =========
	// ========= 产品推荐区域样式 =========
	// ========= 产品推荐区域样式 =========
	// ========= 产品推荐区域样式 =========
	// ========= 产品推荐区域样式 =========
	// ========= 产品推荐区域样式 =========
	// ========= 产品推荐区域样式 =========

	// 推荐容器
	.recommend-box {
	margin: 10px 0;
	padding: 12px 16px;
	background: #f8fbfc;
	border: 1px solid #218da0;
	border-radius: 6px;
	
	&::before {
		content: '';
		display: block;
		height: 2px;
		background: linear-gradient(90deg, #218da0, #34c8d9);
		border-radius: 2px;
		margin-bottom: 12px;
	}
	}

	// 标题栏
	.recommend-title {
	display: flex;
	align-items: center;
	justify-content: space-between;
	font-size: 15px;
	font-weight: 600;
	color: #1a1617;
	margin-bottom: 12px;
	
	.left {
		display: flex;
		align-items: center;
		
		&::before {
		content: '★';
		color: #ff9900;
		margin-right: 6px;
		font-size: 16px;
		}
	}
	
	.refresh {
		font-size: 12px;
		color: #218da0;
		cursor: pointer;
		
		&:hover {
		text-decoration: underline;
		}
		
		i {
		margin-right: 3px;
		font-size: 13px;
		}
	}
	}

	// 产品列表（横向滚动）
	.recommend-list {
	display: flex;
	gap: 12px;
	overflow-x: auto;
	padding-bottom: 8px;
	
	&::-webkit-scrollbar {
		height: 5px;
	}
	&::-webkit-scrollbar-thumb {
		background: #218da0;
		border-radius: 3px;
	}
	&::-webkit-scrollbar-track {
		background: #eee;
		border-radius: 3px;
	}
	}

	// 单个产品卡片
	.recommend-card {
	flex: 0 0 150px;
	background: #fff;
	border: 1px solid #e6e6e6;
	border-radius: 5px;
	padding: 10px 8px;
	text-align: center;
	cursor: pointer;
	transition: border-color 0.2s, box-shadow 0.2s;
	position: relative;
	
	&:hover {
		border-color: #218da0;
		box-shadow: 0 3px 10px rgba(33, 141, 160, 0.12);
	}
	
	// 标签
	.card-tag {
		position: absolute;
		top: 6px;
		right: 6px;
		padding: 2px 5px;
		font-size: 10px;
		color: #fff;
		border-radius: 3px;
		background: #ff6600;
		
		&.hot { background: #ff4757; }
		&.new { background: #2ed573; }
	}
	
	// 图片
	.card-img {
		width: 100%;
		height: 110px;
		display: flex;
		align-items: center;
		justify-content: center;
		background: #fafafa;
		border-radius: 4px;
		margin-bottom: 8px;
		overflow: hidden;
		
		img {
		max-width: 100%;
		max-height: 100%;
		object-fit: contain;
		}
	}
	
	// 名称
	.card-name {
		font-size: 12px;
		color: #333;
		line-height: 1.4;
		height: 34px;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		margin-bottom: 6px;
		word-break: break-word;
	}
	
	// 价格
	.card-price {
		margin-bottom: 8px;
		
		.price-now {
		color: #ff6600;
		font-size: 15px;
		font-weight: bold;
		margin-right: 4px;
		}
		.price-origin {
		color: #999;
		font-size: 11px;
		text-decoration: line-through;
		}
	}
	
	// 添加按钮
	.card-btn {
		width: 100%;
		padding: 5px 0;
		font-size: 11px;
		background: #218da0;
		color: #fff;
		border: none;
		border-radius: 3px;
		cursor: pointer;
		
		&:hover {
		background: #1a6e7d;
		}
		
		&:disabled {
		background: #ccc;
		cursor: not-allowed;
		}
	}
	}

	// 空状态
	.recommend-empty {
	text-align: center;
	padding: 20px 0;
	color: #999;
	font-size: 13px;
	
	i {
		font-size: 32px;
		margin-bottom: 8px;
		color: #ddd;
	}
	}

	// 响应式
	@media (max-width: 1200px) {
	.recommend-card {
		flex: 0 0 135px;
		.card-img { height: 95px; }
		.card-name { font-size: 11px; height: 30px; }
	}
	}

	@media (max-width: 768px) {
	.recommend-box { padding: 10px 12px; }
	.recommend-card {
		flex: 0 0 115px;
		padding: 8px 6px;
		.card-img { height: 85px; }
		.card-name { font-size: 10px; height: 28px; }
		.card-price .price-now { font-size: 13px; }
	}
	}
</style>
